import { render, staticRenderFns } from "./cca_detail.vue?vue&type=template&id=7560715e&scoped=true&"
import script from "./cca_detail.vue?vue&type=script&lang=js&"
export * from "./cca_detail.vue?vue&type=script&lang=js&"
import style0 from "./cca_detail.vue?vue&type=style&index=0&id=7560715e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7560715e",
  null
  
)

export default component.exports